export const laoChatbot: Record<string, string> = {
  Chatbot: 'ແຊັດບອດ',
  'Connect your AI provider and control access, usage and costs across every business.':
    'ເຊື່ອມຕໍ່ຜູ້ໃຫ້ບໍລິການ AI ແລະ ຄວບຄຸມສິດ, ການໃຊ້ງານ ແລະ ຄ່າໃຊ້ຈ່າຍຂອງທຸກທຸລະກິດ.',
  'Reload settings': 'ໂຫຼດການຕັ້ງຄ່າໃໝ່',
  'AI enabled': 'ເປີດ AI ແລ້ວ',
  'AI paused': 'ຢຸດ AI ຊົ່ວຄາວ',
  Available: 'ພ້ອມໃຊ້ງານ',
  'Managed in Control Center': 'ຈັດການໃນສູນຄວບຄຸມ',
  'Using server environment settings': 'ໃຊ້ການຕັ້ງຄ່າຂອງເຊີບເວີ',
  'Requests today': 'ຄຳຮ້ອງຂໍມື້ນີ້',
  'Tokens today': 'ໂທເຄັນມື້ນີ້',
  'Tokens this month': 'ໂທເຄັນເດືອນນີ້',
  'Estimated cost this month': 'ຄ່າໃຊ້ຈ່າຍປະມານເດືອນນີ້',
  'Estimated cost this month (USD)': 'ຄ່າໃຊ້ຈ່າຍປະມານເດືອນນີ້ (USD)',
  'Active / queued': 'ກຳລັງໃຊ້ / ລໍຖ້າ',
  'failed or uncertain attempts this month': 'ຄຳຮ້ອງຂໍລົ້ມເຫຼວ ຫຼື ບໍ່ແນ່ນອນເດືອນນີ້',
  'API connection': 'ການເຊື່ອມຕໍ່ API',
  'Limits & access': 'ຂີດຈຳກັດ ແລະ ສິດ',
  'Usage & reliability': 'ການໃຊ້ງານ ແລະ ຄວາມໝັ້ນຄົງ',
  'Provider connection': 'ເຊື່ອມຕໍ່ຜູ້ໃຫ້ບໍລິການ',
  'API credentials': 'ຂໍ້ມູນຢືນຢັນ API',
  'Credentials are stored encrypted and never returned to the browser.':
    'ກະແຈຖືກເກັບແບບເຂົ້າລະຫັດ ແລະ ບໍ່ສົ່ງຄືນໄປຫາບຣາວເຊີ.',
  'Enable AI across the platform': 'ເປີດ AI ສຳລັບທັງລະບົບ',
  Provider: 'ຜູ້ໃຫ້ບໍລິການ',
  'Primary model': 'ໂມເດລຫຼັກ',
  'Fallback model': 'ໂມເດລສຳຮອງ',
  'Fallback model (optional)': 'ໂມເດລສຳຮອງ (ບໍ່ບັງຄັບ)',
  'Enter your provider’s model ID': 'ໃສ່ລະຫັດໂມເດລຂອງຜູ້ໃຫ້ບໍລິການ',
  'API base URL': 'URL ຫຼັກຂອງ API',
  'Use the base URL before /chat/completions. Production requires HTTPS.':
    'ໃຊ້ URL ຫຼັກກ່ອນ /chat/completions. ລະບົບຈິງຕ້ອງໃຊ້ HTTPS.',
  'Replace API key': 'ປ່ຽນກະແຈ API',
  'A key is saved. Leave blank to keep it.': 'ມີກະແຈບັນທຶກແລ້ວ. ປະໄວ້ຫວ່າງເພື່ອໃຊ້ກະແຈເດີມ.',
  'Paste your provider API key': 'ວາງກະແຈ API ຂອງທ່ານ',
  'Hide API key': 'ເຊື່ອງກະແຈ API',
  'Show API key': 'ສະແດງກະແຈ API',
  'Remove the saved API key on save': 'ລຶບກະແຈ API ເມື່ອບັນທຶກ',
  'Uses the same endpoint and key. Each attempt counts toward limits.':
    'ໃຊ້ URL ແລະ ກະແຈດຽວກັນ. ທຸກຄຳຮ້ອງຂໍນັບໃນຂີດຈຳກັດ.',
  'Request controls': 'ຄວບຄຸມຄຳຮ້ອງຂໍ',
  'Timeout (milliseconds)': 'ເວລາໝົດກຳນົດ (ມິລິວິນາທີ)',
  'Concurrent requests per server': 'ຄຳຮ້ອງຂໍພ້ອມກັນຕໍ່ເຊີບເວີ',
  'Maximum output tokens': 'ໂທເຄັນຄຳຕອບສູງສຸດ',
  'Output token parameter': 'ພາລາມິເຕີໂທເຄັນຄຳຕອບ',
  'Temperature (optional)': 'Temperature (ບໍ່ບັງຄັບ)',
  'Provider default': 'ຄ່າເລີ່ມຕົ້ນຜູ້ໃຫ້ບໍລິການ',
  'Provider options (JSON)': 'ຕົວເລືອກຜູ້ໃຫ້ບໍລິການ (JSON)',
  'Test saved connection': 'ທົດສອບການເຊື່ອມຕໍ່ທີ່ບັນທຶກ',
  'Charge usage to workspace': 'ນັບການໃຊ້ງານໃຫ້ທຸລະກິດ',
  'Model to test': 'ໂມເດລທີ່ຈະທົດສອບ',
  'Test connection': 'ທົດສອບການເຊື່ອມຕໍ່',
  'Testing…': 'ກຳລັງທົດສອບ…',
  'Save your changes before testing.': 'ບັນທຶກການປ່ຽນແປງກ່ອນທົດສອບ.',
  'Connection verified': 'ຢືນຢັນການເຊື່ອມຕໍ່ແລ້ວ',
  'Test unsuccessful': 'ທົດສອບບໍ່ສຳເລັດ',
  tokens: 'ໂທເຄັນ',
  'Protection & behavior': 'ການປ້ອງກັນ ແລະ ການເຮັດວຽກ',
  'Encrypted server-side credentials': 'ກະແຈເຂົ້າລະຫັດໃນເຊີບເວີ',
  'Platform administrators only; all changes and tests are audited.':
    'ສະເພາະຜູ້ດູແລລະບົບ; ທຸກການປ່ຽນແປງ ແລະ ທົດສອບມີບັນທຶກ.',
  'Open activity log': 'ເປີດປະຫວັດກິດຈະກຳ',
  'Token pricing': 'ລາຄາໂທເຄັນ',
  'USD per million tokens': 'USD ຕໍ່ໜຶ່ງລ້ານໂທເຄັນ',
  'Input token price': 'ລາຄາໂທເຄັນຂາເຂົ້າ',
  'Output token price': 'ລາຄາໂທເຄັນຂາອອກ',
  'Platform limits': 'ຂີດຈຳກັດທັງລະບົບ',
  'Workspace defaults': 'ຄ່າເລີ່ມຕົ້ນທຸລະກິດ',
  'Requests per minute': 'ຄຳຮ້ອງຂໍຕໍ່ນາທີ',
  'Requests per day': 'ຄຳຮ້ອງຂໍຕໍ່ມື້',
  'Daily token limit': 'ຂີດຈຳກັດໂທເຄັນຕໍ່ມື້',
  'Monthly token limit': 'ຂີດຈຳກັດໂທເຄັນຕໍ່ເດືອນ',
  'Monthly cost limit (USD)': 'ຂີດຈຳກັດຄ່າໃຊ້ຈ່າຍຕໍ່ເດືອນ (USD)',
  'Unsaved changes': 'ຍັງບໍ່ບັນທຶກການປ່ຽນແປງ',
  'All changes saved': 'ບັນທຶກການປ່ຽນແປງທັງໝົດແລ້ວ',
  'Save settings': 'ບັນທຶກການຕັ້ງຄ່າ',
  'Chatbot settings saved': 'ບັນທຶກການຕັ້ງຄ່າແຊັດບອດແລ້ວ',
  'Workspace access & limits': 'ສິດ ແລະ ຂີດຈຳກັດທຸລະກິດ',
  'Platform allowance': 'ໂຄຕາລະບົບ',
  'Workspace usage': 'ການໃຊ້ງານທຸລະກິດ',
  'Recent provider attempts': 'ຄຳຮ້ອງຂໍຫາຜູ້ໃຫ້ບໍລິການລ່າສຸດ',
  'Estimated USD': 'ປະມານ USD',
  'Custom limits': 'ຂີດຈຳກັດສະເພາະ',
  Allowed: 'ອະນຸຍາດ',
  'Guest AI enabled': 'ເປີດ AI ສຳລັບແຂກ',
  'Guest AI not enabled': 'ຍັງບໍ່ເປີດ AI ສຳລັບແຂກ',
  'Today’s tokens / limit': 'ໂທເຄັນມື້ນີ້ / ຂີດຈຳກັດ',
  'Monthly tokens / limit': 'ໂທເຄັນເດືອນນີ້ / ຂີດຈຳກັດ',
  'Estimated cost / limit': 'ຄ່າໃຊ້ຈ່າຍປະມານ / ຂີດຈຳກັດ',
  'Workspace limits': 'ຂີດຈຳກັດທຸລະກິດ',
  'AI access': 'ສິດໃຊ້ AI',
  'Allow AI for this workspace': 'ອະນຸຍາດ AI ໃຫ້ທຸລະກິດນີ້',
  'Zero blocks AI': 'ຄ່າສູນຈະບລັອກ AI',
  'Use workspace defaults': 'ໃຊ້ຄ່າເລີ່ມຕົ້ນທຸລະກິດ',
  'Save policy': 'ບັນທຶກນະໂຍບາຍ',
  'Workspace chatbot policy saved': 'ບັນທຶກນະໂຍບາຍແຊັດບອດທຸລະກິດແລ້ວ',
  'Use defaults': 'ໃຊ້ຄ່າເລີ່ມຕົ້ນ',
  'Use workspace defaults?': 'ໃຊ້ຄ່າເລີ່ມຕົ້ນທຸລະກິດບໍ?',
  'Discard unsaved changes?': 'ຍົກເລີກການປ່ຽນແປງທີ່ຍັງບໍ່ບັນທຶກບໍ?',
  'Reloading replaces your draft with the latest saved settings.':
    'ການໂຫຼດໃໝ່ຈະປ່ຽນແບບຮ່າງເປັນການຕັ້ງຄ່າທີ່ບັນທຶກລ່າສຸດ.',
  'Workspace policies apply immediately. Platform limits still apply.':
    'ນະໂຍບາຍທຸລະກິດມີຜົນທັນທີ. ຂີດຈຳກັດລະບົບຍັງນຳໃຊ້.',
  succeeded: 'ສຳເລັດ',
  reserved: 'ຈອງໂຄຕາ',
  uncertain: 'ບໍ່ແນ່ນອນ',
};
